var path = '/components/state-manager/filter-field/types/number.tpl.html';
var html = "<input class=\"form-control text-muted\" placeholder=\"{{vm.col.search_text}}\" ng-model=\"search\"\n       ng-init=\"search = vm.store.state.filters[vm.col.key]\"\n       ng-enter=\"vm.store.dispatch('filterCol', {col: vm.col, value: search})\"\n       ng-blur=\"vm.store.dispatch('filterCol', {col: vm.col, value: search})\">";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/state-manager/filter-field/types/number.tpl.html
// module id = 2024
// module chunks = 1